export default {
  'movementDailyMovementReport.form.filterByDate': 'Filter by date',
  'movementDailyMovementReport.form.filterByDate.entrance': 'Entrance',
  'movementDailyMovementReport.form.filterByDate.authorization':
    'Authorization',
  'movementDailyMovementReport.form.filterByDate.shutdown': 'Shutdown',
  'movementDailyMovementReport.form.filterByDate.exit': 'Exit',
  'movementDailyMovementReport.form.filterByDate.info':
    'When the option to filter by close date is selected along with the direct sell option, direct sales will be filtered by their authorization date',

  'movementDailyMovementReport.form.situation': 'Situation',
  'movementDailyMovementReport.form.situation.open': 'Open',
  'movementDailyMovementReport.form.situation.authorized': 'Authorized',
  'movementDailyMovementReport.form.situation.closed': 'Closed',
  'movementDailyMovementReport.form.situation.canceled': 'Canceled',

  'movementDailyMovementReport.form.groupReportBy': 'Group Report By',
  'movementDailyMovementReport.form.groupReportBy.date': 'Date',
  'movementDailyMovementReport.form.groupReportBy.estimatorAndSalesperson':
    'Estimator/SalesPerson',
  'movementDailyMovementReport.form.groupReportBy.customer': 'Customer',

  'movementDailyMovementReport.form.checkbox.parts': 'Parts',
  'movementDailyMovementReport.form.checkbox.partsProvided': 'Parts Provided',
  'movementDailyMovementReport.form.checkbox.tasks': 'Services',
  'movementDailyMovementReport.form.checkbox.third': 'The 3rd',
  'movementDailyMovementReport.form.checkbox.directSale': 'Direct Sale',
  'movementDailyMovementReport.form.checkbox.synthetic': 'Synthetic?',
  'movementDailyMovementReport.form.checkbox.showMlb':
    'Show Gross Profit Margin',

  'movementDailyMovementReport.form.moreOptions': 'More Options',
  'movementDailyMovementReport.form.moreOptions.estimatorAndSalesperson':
    'Estimator/SalesPerson',
  'movementDailyMovementReport.form.moreOptions.button.selectCustomers':
    'Select Customers',
  'movementDailyMovementReport.form.moreOptions.groups': 'Group',
  'movementDailyMovementReport.form.moreOptions.ncm': 'NCM',
};
